import { clsx } from "clsx";

export interface StepProgressProps {
  /** Total number of steps in the wizard. */
  total: number;
  /** 1-based index of the currently active step. Steps ≤ current render as filled. */
  current: number;
  className?: string;
  "aria-label"?: string;
}

export function StepProgress({
  total,
  current,
  className,
  "aria-label": ariaLabel = "Progress",
}: StepProgressProps) {
  return (
    <div
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuenow={current}
      aria-valuemin={1}
      aria-valuemax={total}
      className={clsx("flex w-full items-center gap-3", className)}
    >
      {Array.from({ length: total }).map((_, i) => (
        <span
          key={i}
          className={clsx(
            "h-[7px] flex-1 rounded-full transition-colors",
            i < current ? "bg-brandPrimary" : "bg-bgDisabled",
          )}
        />
      ))}
    </div>
  );
}
